import { SearchNotificationsResponse } from "src/service/query";

import { NotificationInterface, NotificationRaisedByType } from "../../models/notification";
import { convertDateToStringDDMMYYYY } from "../date";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const mapNotificationResponse = (r: SearchNotificationsResponse["results"][0]): NotificationInterface => ({
  uuid: r.uuid,
  text: r.message,
  date: convertDateToStringDDMMYYYY(r.createdAt),
  raisedBy: r.raisedByType as NotificationRaisedByType,
  userInitials: r.raisedByUser
    ? `${r.raisedByUser.firstName[0] ?? ""}${r.raisedByUser.lastName[0] ?? ""}`.toUpperCase()
    : undefined,
  unread: !r.isRead,
  isDismissed: r.isDismissed,
  url: r.url,
  objectType: r.objectType,
  objectUuid: r.objectUuid,
});
